var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#5D5CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94098 12.3707L8.04688 14.4766L13.8679 8.6555L11.762 6.5496L5.94098 12.3707Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2253 6.31124L14.1066 5.1925C13.834 4.91989 13.3728 4.93914 13.0764 5.23551L12.0254 6.28657L14.1313 8.39244L15.1823 7.34141C15.4786 7.04504 15.4979 6.58382 15.2253 6.31124Z",
    fill: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74455 12.7021L5.18578 14.7394C5.10378 15.0384 5.37837 15.313 5.67735 15.231L7.71436 14.6722L5.74455 12.7021Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-blue.d3921bfa.svg";
export { ForwardRef as ReactComponent };